import React, { useEffect, useMemo, useState, useRef,useContext } from "react";
import Button from "components/button/button";
import Input from "components/input/input";
import Select from "components/select/select";
import CreatableSelect from "components/select/creatable";
import {
  // gender,
  // profileTypes,
  // heroTypes,
  // heroCTAs,
  heroIcon,
  maxUploadProfileSize,
  sampleCategory
} from "utils/constant";
import { FiCamera } from "react-icons/fi";
import Toggle from "components/toggle/toggle";
import update from "immutability-helper";
import SocialSelect from "./component/SocialSelect";
import ImageUpload from "components/image-upload/image-upload";
import { CoverPlaceholder, ProfilePlaceholder } from "constants/images";
import toast from "react-hot-toast";
import LoadingIndicator from "assets/svg/loading-indicator";
import _ from "lodash";
import { useHistory,Link } from "react-router-dom";
import { urlSerializer,randomExtension } from "utils/utils";
import { ORGANIZE_BY } from "constants/options";
import { useDialogHook } from "utils/customhooks";
import CropThumbnailModal from "components/profile/milestones/crop-thumbnail";
import CropCoverModal from "components/profile/milestones/crop-cover";
import { useOccupations } from "redux/modules/occupation/hooks";
import { usePositionFilter } from "redux/modules/position-filter/hooks";
import { useCategoryFilter } from "redux/modules/category-filter/hooks";
import { social } from "utils/constant";
import PopInfo from "components/info-popup/pop-info";
import Members from "./component/Members";
import WebsiteSelect from "./component/WebsiteSelect";
import ToolTip from "components/tootltip/tootltip";
import { usePlacesWidget } from "react-google-autocomplete";
import { FiAlertCircle } from "react-icons/fi";
import DragDropSelect from "./component/DragDropSelect";
import EditCoverPhoto from "./component/EditCoverPhoto";
import { usePrivacies } from "redux/modules/privacy/hooks";
import ArrowLeftIcon from "assets/svg/arrow-left-icon";
import { useTranslation,Trans } from "react-i18next";
import { LangContext } from "context/language";
import UpgradePremium from "components/subscription/upgrade-premium";
import { SubscriptionContext } from "context/subscription";
import EditProfilePhoto from "./component/EditProfilePhoto";
import { useProfileGallery } from "redux/modules/profile-gallery/hooks";
import useProfileGalleryHook from "utils/useProfileGaller";


export default function SettingsGeneral({
  userData = null,
  setUserData = () => {},
}) {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const extension = randomExtension();
  const { http, localstorage } = global.services;
  // const crop = useDialogHook(EditThumbnailModal);
  const cropProfile = useDialogHook(CropThumbnailModal);
  const cropCover = useDialogHook(CropCoverModal);
  const editCover = useDialogHook(EditCoverPhoto);
  const editProfile = useDialogHook(EditProfilePhoto);
  const {heroCTAs,heroTypes,languages} = useContext(LangContext);
  const { isSubscribed } = useContext(SubscriptionContext);

  /**
   * Cleans a language value (removes quotes/whitespace, lowercases) and
   * checks it against the available languages.
   * - Returns the clean code if it is valid.
   * - Returns null if it is invalid (e.g. "null", "English", "en_US", "").
   * - If `languages` has not loaded yet, the clean code is returned as-is,
   *   and the effect below validates it once the list arrives.
   */
  const normalizeLang = (val) => {
    if (typeof val !== "string") return null;
    const code = val.replace(/["']/g, "").trim().toLowerCase();
    if (!code || code === "null" || code === "undefined") return null;
    if (!languages || languages.length === 0) return code;
    return languages.some((l) => l.value === code) ? code : null;
  };

  // Sorted copies so we never mutate the arrays that live in the context
  const sortedLanguages = useMemo(
    () => [...(languages || [])].sort((a, b) => a.label.localeCompare(b.label)),
    [languages]
  );

  const sortedHeroCTAs = useMemo(
    () => [...(heroCTAs || [])].sort((a, b) => a.label.localeCompare(b.label)),
    [heroCTAs]
  );

  const sortedHeroTypes = useMemo(
    () =>
      [...(heroTypes || [])].sort((a, b) => {
        if (a.label === "Other") return 1;
        if (b.label === "Other") return -1;
        return a.label.localeCompare(b.label);
      }),
    [heroTypes]
  );

  const gender = [
    { label: t("male"), value: "Male" }, 
    { label: t("female"), value: "Female" },
    { label: t("other"), value: "Other" }
  ];

 const profileTypes = [
    { label: t("personal"), value: "personal" },
    { label: t("business"), value: "business" },
    { label: t("group"), value: "group" },
    { label: t("team"), value: "team" },
    { label: t("character"), value: "character" },
  ];
   

  const user_data = JSON.parse(localStorage.getItem("user_data"));
  const user = user_data?.user || null;
  const profUsername = user_data?.profile || null;
  const sets_display_name = [
    { label: user?.first_name || '', value: "First Name" },
    { label: user?.last_name || '', value: "Surename" },
    { label: `${user?.first_name || ''} ${user?.last_name || ''}`, value: "First Name Surname" },
    { label: profUsername?.username || '', value: "Username" },
    // { label: 'Other Name' || '', value: "Other Name" },
  ];

  const dateForamtList = [
    {
      label:"USA (Month Day Year Format)",
      value:false,
    },
    {
      label:"International (Day Month Year Format)",
      value:true,
    }
  ]

  const {
      refresh: refreshPrivacies,
      initialize: initializePrivacies,
      privacies,
      setPrivacies,
    } = usePrivacies();

  const [displayName, setDisplayName] = useState(sets_display_name)
  const fileInputRef = useRef(null);
  const {
    refresh: refreshPoisitionFilter,
    initialize: initializePositionFilter,
    options: positionOptions,
    setPositionFilter,
  } = usePositionFilter();

  const { ref } = usePlacesWidget({
    apiKey:process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    onPlaceSelected: (place) => {
      setState((prev) => ({
        ...prev,
        address: place.formatted_address,
        validationErrors: { ...state.validationErrors, address: null },
      }));
    }
  });

  const {
    refresh: refreshCategoryFilter,
    initialize: initializeCategoryFilter,
    setCategoryFilter,
  } = useCategoryFilter();

  const {
    setPhotos: setProfileGallery,
    photos: profileGallery,
    initialize: initializeProfileGallery,
    total:totalPG,
    limit:limitPG,
    finishGetPhoto,
    isRequesting: isRequestingPG,
    loadMore: loadMorePG


  } = useProfileGallery()

  const {
    refresh: refreshOccupation,
    initialize: initializeOccupation,
    occupations,
    setOccupations,
    addOccupation,
  } = useOccupations();

  const [websites, setWebsites] = useState([
    { social: "", link: "", media_type: "website", label: "" },
  ]);
  //const [websitesClone, setWebsitesClone] = useState();
  const [socials, setSocials] = useState([
    { social: "", link: "", media_type: "social", order:0 },
  ]);
  const [socialsClone, setSocialsClone] = useState([
    { social: "", link: "", media_type: "social" },
  ]);
  const [otherNames, setOtherNames] = useState([
    { index: "", label:"" , value:""},
  ]);
  const [members, setMembers] = useState([]);
  const [profile, setProfile] = useState(ProfilePlaceholder);
  const [cover, setCover] = useState(CoverPlaceholder);
  // const [profileImage, setProfileImage] = useState(ProfilePlaceholder);
  // const [keyword, setKeyword] = useState([]);
  const [occupation, setOccupation] = useState([]);
  const [state, setState] = useState({
    profile_image_file: null,
    cover_image_file: null,
    username: null,
    email: null,
    profile_username: null,
    other_name: null,
    address: null,
    condition: true,
    loading: false,
    validationErrors: null,
    adultContent: false,
    featured: true,
    showNotifications: true,
    allowTagging: true,
    metadata: {},
    other_gender: null,
    hero: {},
    dateFormat: true,
    profile_type: {},
    profileTypes: profile?.profile_type,
    displayName:null,
    profile_name:null,
    list_covers:[],
    preview_covers:[],
    status:null,
    media_id:null,
    privacy:null,
    other_hero_social_media: "",
    lang: normalizeLang(localStorage.getItem('lang')) || "en",
    profile_images:profileGallery || [],
    followers:true,
    turnOnQuickCreate:false

  });
  const [socialOptions, setSocialOptions] = useState(social);
  const [uploadErrors, setUploadErrors] = useState(null);

  const placeholderMap = {
  personal: 'e.g Dame Edna Everage',
  group: 'e.g ABC Group',
  team: 'e.g ABC Group',
  business: 'e.g Your Business Name',
  default: 'e.g Your Character Name'
};

const placeholder =
  placeholderMap[state.profileTypes] || placeholderMap.default;

  const filteredProfileTypes = useMemo(() => {
    if(state.profileTypes !== "personal") {
      return profileTypes.filter((type) => type.value !== "personal");
    }

  }, [state.profileTypes]);

  const {getProfileGallery} = useProfileGalleryHook({
    userID : userData?.profile.id, isRequestingPG, loadMorePG,
    totalPG, limitPG, setState, setProfileGallery, finishGetPhoto,http
  })

  const handleInputChange = (e, others_name = false) => {
    const { name, value } = e.target; 
    if(others_name){
      let isOtherName = sets_display_name.find(item => item.value === value);
      if(typeof isOtherName === 'undefined'){
        setState((prev) => ({
          ...prev,
          [name]: value,
          other_name: value,
          validationErrors: { ...state.validationErrors, [name]: null },
        })); 
        return;
      }
    } 
    setState((prev) => ({
      ...prev,
      [name]: value,
      validationErrors: { ...state.validationErrors, [name]: null },
    }));
    if(name === 'lang'){
      localstorage.set('lang',value);
      i18n.changeLanguage(value);
      const privClone = _.cloneDeep(privacies); 
      const privaciesUpdate = privClone.map((p) => ({
         ...p,
        label: p[value] ?? p.name,
        value: p.name 
      }));
      setPrivacies(privaciesUpdate);
    }
  };

  const handleInputObjectChange = (e, object) => {
    const { name, value } = e.target;

    setState((prev) => ({
      ...prev,
      [object]: { ...prev[object], [name]: value },
    }));
  };

  const onChangeOccupation = (e) => {
    setOccupation(e);
  };

  const createOccupation = async (value) => {
    try {
      let { data } = await http.post("public/occupations", {
        user_id: userData.user.id,
        user_profile_id: userData.profile.id,
        occupation: value,
        profile_type:state.profileTypes === 'character' ? 'personal' :  state.profileTypes
      });
      setOccupation((prev) => [...prev, { label: value, value: data.data.id, profile_type:state.profileTypes === 'character' ? 'personal' :  state.profileTypes }]);
      addOccupation({
        label: value,
        value: data.data.id,
        profile_type:state.profileTypes
      });
    } catch (err) {
      console.log(err);
    }
  };

  const onAddSocials = (media_type) => {
    if (media_type === "social") {
      let payload = _.clone(socials);
      payload.push({ social: "", link: "", media_type: "social",order:socials.length });
      setSocials(payload);
    } else if (media_type === "website") {
      let payload = _.clone(websites);
      payload.push({ social: "", link: "", media_type: "website", label: "",order:socials.length});
      setWebsites(payload);
    }
  };

  const onAddOtherName = ()=>{
    let payload = _.clone(otherNames);
    payload.push({ index: "", label: "", value: "",});
    setOtherNames(payload);
    let newArray = [...sets_display_name, ...payload];
    setDisplayName(newArray);
  }

  const onRemoveSocials = (index, media_type) => {
    if (media_type === "social") {
      let options = socialOptions.map((so) => {
        if (so.value === socials[index].social) {
          const { selected, ...val } = so;
          return val;
        }
        return so;
      });
      
      let removeValidation = removeSocialErrorByIndex(state.validationErrors, index,socials);
      setState((prev) => ({
        ...prev,
        validationErrors: {...removeValidation },
      }));

      setSocialOptions((prev) => options);
      let payload = _.clone(socials);
      let result = update(payload, { $splice: [[index, 1]] }); //remove 
      setSocials(result);
    } else if (media_type === "website") {
      let payload = _.clone(websites);
      let result = update(payload, { $splice: [[index, 1]] }); //remove
      setWebsites(result);
    } 
  };

  const removeSocialErrorByIndex = (errorObj, indexToRemove,options) => {
      if(!_.isEmpty(errorObj)){ 
        const socialKeys = Object.keys(errorObj).filter(key => key.startsWith('social'));
        
        if(!_.isEmpty(socialKeys)){  
          const keyToRemove = socialKeys[indexToRemove];
          let { [keyToRemove]: _, ...remainingErrors } = errorObj;
          const newErrors = Object.keys(remainingErrors).reduce((acc, key) => {
            const match = key.split(".");
            const index = parseInt(match[1], 10); 
            if (key.match(/^social\.(\d+)\.type$/) && index !== indexToRemove) {
              if(index > indexToRemove){
                let newIndex = index - 1;
                const newKey = `social.${newIndex}.${match[2]}`;
                acc[newKey] = errorObj[key];
              }else{
                const newKey = `social.${index}.${match[2]}`;
                acc[newKey] = errorObj[key];
              }
            }
            return acc;
          }, {});
  
          return newErrors;
        }
       
      }
      
  };

  const onRemoveOtherName = (index) => { 
      let payload = _.clone(otherNames);
      let result = update(payload, { $splice: [[index, 1]] }); //remove
      setOtherNames(result); 
      let newArray = [...sets_display_name, ...result];
      setDisplayName(newArray);
    
  };

  const onSelectSocial = (e, index) => {
    let _remove = "";
    let value = e ? e.value : "";

    if (!value) {
      _remove = socials[index].social;
    }

    let options = socialOptions.map((so) => {
      if (so.value === value) {
        return {
          ...so,
          selected: true,
        };
      } else if (so.value === _remove) {
        const { selected, ...val } = so;
        return val;
      }

      return so;
    });
    setSocialOptions((prev) => options);

    let payload = _.clone(socials);
    let result = update(payload, {
      [index]: {
        social: { $set: value },
      },
    }); //remove
    setSocials(result);
  };

  const onAddMembers = () => {
    let payload = _.clone(members);
    payload.push({ name: "", role: "", dateSE: "" });
    setMembers(payload);
  };

  const onRemoveMembers = (index) => {
    let payload = _.clone(members);
    let result = update(payload, { $splice: [[index, 1]] }); //remove
    setMembers(result);
  };

  const onChangeMembers = (e, index) => {
    e.stopPropagation();

    let name = "";
    if (e.target.name === `name-${index}`) {
      name = e.target.value;
    } else {
      name = members[index].name;
    }

    let role = "";
    if (e.target.name === `role-${index}`) {
      role = e.target.value;
    } else {
      role = members[index].role;
    }

    let dateSE = "";
    if (e.target.name === `dateSE-${index}`) {
      dateSE = e.target.value;
    } else {
      dateSE = members[index].dateSE;
    }

    let payload = _.clone(members);
    let result = update(payload, {
      [index]: {
        name: { $set: name },
        role: { $set: role },
        dateSE: { $set: dateSE },
      },
    });
    setMembers(result);
  };

  const checkIconLink = (link) => {
    let tempSocial = [...social];
    let setType = link.replace(/.+\/\/|www.|\..+/g, "").toLowerCase(); //get domain name and set into type
    return tempSocial
      .map((obj) =>
        link.toLowerCase().includes(obj.site) ? obj.value : setType
      )
      .filter((value) => value !== setType);
  };

  const checkUrl = (e, index, media_type) => {
    if (
      !e.target.value.includes("https://") &&
      !e.target.value.includes("http://")
    ) {

      if(_.isEmpty(e.target.value)){
        return;
      } 
      let addProtocol = `https://${e.target.value}`;
      let payload = [];
      if (media_type === "social") {
        payload = _.clone(socials);
      } else if (media_type === "website") {
        payload = _.clone(websites);
      }

      let result = update(payload, {
        [index]: {
          link: { $set: addProtocol },
        },
      }); //remove

      if(!result[index].label && media_type === "website") {
        const linkLabel = new URL(addProtocol).hostname?.replace(/^www\./gi, "").split(".")[0];
        result[index].label = linkLabel;
      }

      if (media_type === "social") {
        setSocials(result);
      } else if (media_type === "website") {
        setWebsites(result);
      }
    } else {
      if(media_type === "website") {
        const result =  _.clone(websites);
        console.log(`result[${index}].label`, result[index].label);
        if(!result[index].label) {
          const linkLabel = new URL(e.target.value).hostname?.replace(/^www\./gi, "").split(".")[0];
          result[index].label = linkLabel;
        }
        setWebsites(result);
      }
      return;
    }
  };

  const onTypeLinkSocial = (e, index, media_type) => {
    let setType = e.target.value.replace(/.+\/\/|www.|\..+/g, "").toLowerCase();
    let payload = [];
    if (media_type === "social") {
      payload = _.clone(socials);
    } else if (media_type === "website") {
      payload = _.clone(websites);
    }

    let socialVal = checkIconLink(e.target.value)[0] || setType;
    let checkFav =
      payload[index]?.social === socialsClone[index]?.social
        ? socialsClone[index]?.fav_icon
        : null;


    let result = update(payload, {
      [index]: {
        link: { $set: e.target.value },
        social: { $set: socialVal },
        fav_icon: { $set: checkFav },
        order: { $set: index+1 },

      },
    }); //remove

    if (media_type === "social") {
      setSocials(result);
    } else if (media_type === "website") {
      setWebsites(result);
    }
  };

  const onLabelChange = (e, index, media_type) => {
    if(media_type === "website") {
      const payload =  _.clone(websites);
      payload[index].label = e.target.value;
  
      setWebsites(payload);
    }
  };

  const onChangeOtherName = (e, index) => { 
    let payload = [];
    payload = _.clone(otherNames); 
    let result = update(payload, {
      [index]: {
        label: { $set: e.target.value }, 
        index: { $set: index },
        value: { $set: e.target.value }, 
      },
    }); //remove
    setOtherNames(result);
    let newArray = [...sets_display_name, ...result];
    setDisplayName(newArray);
    
  };

  const handleSave = async (e) => {
    e.preventDefault();
    let errors = {};
    setState((prev) => ({ ...prev, loading: true }));

    // Always send a valid language code (never "null", "English", "en_US", etc.)
    const safeLang = normalizeLang(state.lang) || "en";

    let payload = new FormData();
    let params = _.clone(state);
    params.lang = safeLang;
    let tempMember = [...members];
    params.profileGroup = JSON.stringify(tempMember);
    if (state?.heroSocialMedia)
      //re-assign the heroSocialMedia into hero object
      params.hero = {
        ...state.hero,
        socialMedia: state?.heroSocialMedia,
      };
    if (state?.heroCTA)
      //re-assign the heroCTA into hero object
      params.hero = {
        ...state.hero,
        socialMedia: state?.heroSocialMedia,
        heroCTA: state?.heroCTA,
      };
    if (state?.heroCTA)
      //re-assign the heroCTA into hero object
      params.hero = {
        ...state.hero,
        socialMedia: state?.heroSocialMedia,
        heroCTA: state?.heroCTA
      };

    if(params.hero.socialMedia === "Other") {
      params.hero = {
        ...params.hero,
        other_hero_social_media: state?.other_hero_social_media,
      };
    }

    Object.keys(params).forEach((key) => {
      if (key === "gender") return;

      if (key === "hero") params[key] = JSON.stringify(params[key]);

      if (
        (key === "profile_image_file" || key === "cover_image_file") &&
        params[key]
      )
        payload.append(key, params[key]);

      if (typeof params[key] === "boolean" || !_.isEmpty(params[key])) {
        payload.append(key, params[key]);
      }
    });

    let mergeSocialWebsite = [...socials, ...websites];
    mergeSocialWebsite = removeDuplicateSocial(mergeSocialWebsite);

    mergeSocialWebsite.forEach((social, index) => {
      if (social.social || social.link) {
        payload.append(`social[${index}][id]`, social.id || null);
        payload.append(`social[${index}][type]`, social.social);
        payload.append(`social[${index}][link]`, social.link);
        payload.append(`social[${index}][media_type]`, social.media_type);
        payload.append(`social[${index}][label]`, social.label || "");
        payload.append(`social[${index}][order]`, social.order || 0);
      }
    });

    if (occupation.length > 0) {
      let occupationValues = occupation.map((o) => o.label);
      payload.append("occupations", JSON.stringify(occupationValues));
    } else {
      payload.append("occupations", "");
    }

    // if (otherNames.length > 0) { 
    //   payload.append("other_names", JSON.stringify(otherNames));
    // } else {
    //   payload.append("other_names", "");
    // }

    payload.append("user_id", userData.user.id);
    payload.append("user_profile_id", userData.profile.id);
    payload.append("lang", safeLang);
    payload.append("_method", "PUT");

    if (state.gender === "Other" && !state.other_gender && state?.profileTypes == 'personal') {
      toast.error("Please specify gender");
      return setState((prev) => ({
        ...prev,
        loading: false,
        validationErrors: {
          ...errors,
          [`other_gender`]: "Please specify gender",
        },
      }));
    } else if (state.gender === "Other" && state.other_gender) {
      payload.append("gender", state.other_gender);
    } else if(!!state.gender) {
      payload.append("gender", state.gender);
    }

    if (state.heroSocialMedia === "Other" && !state.other_hero_social_media) {
      return setState((prev) => ({
        ...prev,
        loading: false,
        validationErrors: {
          ...errors,
          [`other_hero_social_media`]: "Please specify Hero Label",
        },
      }));
    } else if (state.heroSocialMedia === "Other" && state.other_hero_social_media) {
      payload.append("other_hero_social_media", state.other_hero_social_media);
    }
    try {
      const { data, status } = await http.post(
        `profiles/${userData.profile.id}`,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (status === 200) {
        toast.success(data.message);
        const updatedProfile = { ...data.profile, lang: data.profile?.lang };

        const newUserData = {
          ...userData,
          user: {
            ...userData.user,
            username: state.username,
            email: state.email,
            first_name: state.first_name,
            last_name: state.last_name,
          },
          profile: updatedProfile,
        };

        // If userData contains a profiles array, update the matching profile inside it
        if (Array.isArray(userData.profiles)) {
          newUserData.profiles = userData.profiles.map((p) =>
            p && p.id === updatedProfile.id ? updatedProfile : p
          );
        } else if (userData.profile && userData.profile.id === updatedProfile.id) {
          // fallback: replace single profile field if it matches
          newUserData.profile = updatedProfile;
        }

        localstorage.set("user_data", JSON.stringify(newUserData));
        localStorage.setItem("lang", safeLang);
        setState((prev) => ({
          ...prev,
          profile_image_file: null,
          cover_image_file: null,
          validationErrors: null,
        }));
        setUserData(newUserData);
        history.push(`/${userData?.user?.username}-${extension}/profile/${userData?.profile?.id}`)
      }
    } catch (error) {
      if (error.status === 422) {
        toast.error(t('somethingWentWrong'));
        return setState((prev) => ({
          ...prev,
          validationErrors: error.data?.errors,
        }));
      }

      toast.error(
        error.status === 401
          ? "Invalid Credentials"
          : error?.data?.message || t('somethingWentWrong')
      );
    } finally {
      setState((prev) => ({ ...prev, loading: false }));
    }
  };

  const removeDuplicateSocial = (socailWebsite) => {
    
    const uniqueData = socailWebsite.filter((item, index, self) =>
      index === self.findIndex((t) => t.link === item.link)
    );
    return uniqueData;
    
  }

  const updateCoverPhoto = async (cropFile=null, selectedCover=null)=>{
    try {
      let payload = new FormData();
      payload.append("cover_image_file", cropFile);
      payload.append("user_id", userData.user.id);
      payload.append("user_profile_id", userData.profile.id);
      payload.append("profile_image_id", userData.profile.id);
      payload.append("cover_photo_id", selectedCover?.media_id);
      payload.append("cover_photo_status", selectedCover?.status);
      payload.append("_method", "PUT");
      
      const { data, status } = await http.post(
        `profiles/cover/${userData.profile.id}`,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (status === 200) {
        toast.success(data.message);
        const newUserData = {
          ...userData,
          ...user,
          profile: data.profile,
        };
        let addNewCover = [];
        if(data.new_cover){
          let media_id = data?.media?.id;
          let url = data?.media?.url;
          addNewCover = [...state.preview_covers, {media_id:media_id, url:url }]
        }else{
          addNewCover = [...state.preview_covers]
        }
        

        localstorage.set("user_data", JSON.stringify(newUserData));
        setState((prev) => ({
          ...prev,
          cover_image_file: null,
          validationErrors: null,
          preview_covers:addNewCover,
          // this line will prevent clearing profile picture IF profile was changed and not saved yet
          ...(!(!!profile && !!state.profile_image_file) && {
            profile_image_file: null,
          })
        }));
        setUserData(newUserData);
        return true;
      }
    } catch (error) {
      if (error.status === 422) {
        toast.error(t('somethingWentWrong'));
        return setState((prev) => ({
          ...prev,
          validationErrors: error.data?.errors,
        }));
      }

      toast.error(
        error.status === 401
          ? "Invalid Credentials"
          : error?.data?.message || t('somethingWentWrong')
      );
      console.log(error)
    }
  }

  const updateProfilePhoto = async (cropFile=null, selectedImage=null)=>{
    try {
      let payload = new FormData();
      payload.append("profile_image_file", cropFile);
      payload.append("user_id", userData.user.id);
      payload.append("user_profile_id", userData.profile.id);
      payload.append("profile_image_id", selectedImage?.media_id);
      payload.append("profile_photo_status", selectedImage?.status);
      payload.append("_method", "PUT");
      
      const { data, status } = await http.post(
        `profile/photos/${userData.profile.id}`,
        payload,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (status === 200) {
        toast.success(data.message);
        const newUserData = {
          ...userData,
          ...user,
          profile: data.profile,
        };
        let addNewProfileImage = [];
        if(data.new_profile_image){
          let media_id = data?.media?.id;
          let url = data?.media?.url;
          addNewProfileImage = [...state.profile_images, {media_id:media_id, url:url }]
        }else{
          addNewProfileImage = [...state.profile_images]
        }
        

        localstorage.set("user_data", JSON.stringify(newUserData));
        setState((prev) => ({
          ...prev,
          cover_image_file: null,
          validationErrors: null,
          profile_images:addNewProfileImage,
          // this line will prevent clearing profile picture IF profile was changed and not saved yet
          ...(!(!!profile && !!state.profile_image_file) && {
            profile_image_file: null,
          })
        }));
        setUserData(newUserData);
        setProfileGallery({photos:addNewProfileImage, loadMore:loadMorePG,total:totalPG})
        return true;
      }
    } catch (error) {
      if (error.status === 422) {
        toast.error(t('somethingWentWrong'));
        return setState((prev) => ({
          ...prev,
          validationErrors: error.data?.errors,
        }));
      }

      toast.error(
        error.status === 401
          ? "Invalid Credentials"
          : error?.data?.message || t('somethingWentWrong')
      );
      console.log(error)
    }
  }
  

  const onUploadImage = async (e, type = "profile", ) => {
    // const file = type === "cover" ? e[0] : e.target.files[0];
    const file = e[0];
    const reader = new FileReader();
    reader.addEventListener(
      "load",
      function () {
        if (file.size > maxUploadProfileSize) {
          setUploadErrors({
            ...uploadErrors,
            [type]: "The file is too large. Maximum size is 10MB.",
          });
          return;
        }

        // convert image file to base64 string
        const image = reader.result?.toString() || "";
        let title =
          type === "profile" ? "Crop Profile Picture" : "Crop Cover Photo";
        const Iprops = {
          image: image,
          type: file.type,
          returnType: "file",
          title: title
        };
        if (image) {
          if (type === "profile") {
            Iprops.updateProfilePhoto = updateProfilePhoto;
            cropProfile(Iprops, (result) => {
              if (result) {
                const { imageFile, preview } = result;
                setState((prev) => ({
                  ...prev,
                  profile_image_file: imageFile,
                }));
                setProfile(preview);
              }
            });
            // fileInputRef.current.value = null;
          } else {
            Iprops.updateCoverPhoto = updateCoverPhoto;
            cropCover(Iprops, (result) => {
              if (result) {
                const { imageFile, preview } = result;
                setState((prev) => ({ ...prev, cover_image_file: imageFile,
                  //  list_covers:[...prev.list_covers,imageFile],
                  //  preview_covers:[...prev.preview_covers,preview]
                   }));
                setCover(preview);
                // editCoverHandler([preview]);
              }
            });
          }
        }
      },
      false
    );

    if (file) { 
      if (file.size > maxUploadProfileSize) {
        setUploadErrors({
          ...uploadErrors,
          [type]: "The file is too large. Maximum size is 10MB.",
        });
      } else {
        setUploadErrors(null);
        reader.readAsDataURL(file);
      }
    }
  };

  const editCoverHandler = (newUpload=[])=>{
    let preview_covers = newUpload.length > 0 ? [...state.preview_covers,...newUpload] : state.preview_covers;
    editCover(
      {
        userData,
        profile,
        onUploadImage:(e)=>{onUploadImage(e, "cover")},
        preview_covers:preview_covers,
        cover,
        setCover:(preview)=>{setCover(preview.webp_url || preview.url); setState(prev=>{return {...prev, status:preview.status, media_id:preview.media_id}});},
        updateCoverPhoto
      },
      (callback) => {
        if (callback) {
          // getPhotoVideos();
        }
      }
    );
  }

  const editProfileHandler = (newUpload = []) => {
    let preview_profile_images = newUpload.length > 0 ? [...state.profile_images,...newUpload] : state.profile_images;
    editProfile(
      {
        userData,
        profile,
        onUploadImage:(e)=>{onUploadImage(e, "profile")},
        profileImages:preview_profile_images,
        profileImage:profile,
        setProfile:(preview)=>{setProfile(preview.webp_url || preview.url); setState(prev=>{return {...prev, status:preview.status, media_id:preview.media_id}});},
        updateProfilePhoto,
        http
      },
      (callback) => {
        if (callback) {
          // getPhotoVideos();
        }
      }
    );
  }

  const getPositions = async () => {
    try {
      const url = urlSerializer("public/positions/filter", {
        user_profile_id: userData.profile.id,
      });
      const { data } = await http.get(url);
      const positions = data.map((position) => ({
        label: position.name,
        value: position.id,
      }));
      setPositionFilter(positions);
    } catch (err) {
      console.log("getPosition", err);
    }
  };

  const getCategory = async () => {
    try {
      const url = urlSerializer("public/categories/filter", {
        user_profile_id: userData.profile.id,
      });
      const { data } = await http.get(url);
      const categories = data.map((category) => ({
        label: category.name,
        value: category.id,
      }));
      setCategoryFilter(categories);
    } catch (err) {
      console.log("getCategory", err);
    }
  };

  const getOccupations = async () => {
    try {
      const url = urlSerializer("public/occupations", {
        user_profile_id: userData.profile.id,
      });
      const { data } = await http.get(url);
      const options = data.map((opt) => ({
        label: opt.name,
        value: opt.id,
        profile_type:opt.profile_type
      }));
      setOccupations(options);
    } catch (err) {
      console.log("getOccupations", err);
    }
  };

  const getSocialMedia = async () => {
    let socialMedia = [];
    let websiteMedia = [];

    try {
      const { data } = await http.get("public/social-medias", {
        user_profile_id: userData?.profile.id,
      });
      let result = data?.social_media ?? [];
      if (result.length > 0) {
        result.forEach((sm) => {
          if (sm.media_type === "social") {
            socialMedia.push({
              id:sm?.id || null,
              social: sm.type,
              link: sm.link,
              fav_icon: sm?.fav_icon?.url || null,
              media_type: "social",
              order:sm?.order || 0
            });

            let options = socialOptions.map((so) => {
              if (so.value === sm.type) {
                return {
                  ...so,
                  selected: true,
                };
              }
              return so;
            });
            setSocialOptions((prev) => options);
          }
          if (sm.media_type === "website") {
            websiteMedia.push({
              id:sm?.id || null,
              social: sm.type,
              link: sm.link,
              fav_icon: sm?.fav_icon?.url || null,
              media_type: "website",
              label: sm.label,
              order:sm?.order || 0
            });
          }
        });

        setSocials(socialMedia);
        setSocialsClone(socialMedia);
        setWebsites(websiteMedia);
      }
    } catch (err) {
      console.log("getSocialMedia", err);
    }
  };
  const getCoverPhotos = async () => {
    try {
      const { data } = await http.get("profiles/cover/photos", {
        user_profile_id: userData?.profile.id,
      });
      if(data.length > 0){
        setState(prev => {
          return{
            ...prev,
            preview_covers:data
          }
        });
      }
    } catch (err) {
      console.log("getCoverPhotos", err);
    }
  };

  useEffect(() => {
    if (userData.profile?.profile_image_url)
      setProfile(
        userData.profile.profile_image_webp_url ||
          userData.profile.profile_image_url
      );

    if (userData.profile?.cover_image_url)
      setCover(
        userData.profile.cover_image_webp_url ||
        userData.profile.cover_image_url
           
      );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * This effect will run every time when
   * initialize and refresh state change
   */
  useEffect(() => {
    if (initializePositionFilter) getPositions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshPoisitionFilter, initializePositionFilter]);

  /**
   * This effect will run every time when
   * initialize and refresh state change
   */
  useEffect(() => {
    if (initializeCategoryFilter) getCategory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshCategoryFilter, initializeCategoryFilter]);

  /**
   * This effect will run every time when
   * initialize and refresh state change
   */
  useEffect(() => {
    if (initializeProfileGallery) getProfileGallery();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initializeProfileGallery,getProfileGallery]);

  useEffect(() => {
    if (initializeOccupation) getOccupations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refreshOccupation, initializeOccupation]);

  /**
   * Once the languages list is available (or changes), make sure
   * state.lang is one of its options. If not, fall back to the
   * saved site language, then to English, so the dropdown is never empty.
   */
  useEffect(() => {
    if (!languages || languages.length === 0) return;
    setState((prev) => {
      if (languages.some((l) => l.value === prev.lang)) return prev; // already valid
      const fallback =
        normalizeLang(localStorage.getItem("lang")) ||
        (languages.some((l) => l.value === "en") ? "en" : languages[0].value);
      return { ...prev, lang: fallback };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [languages]);

  /**
   * This effect will run on the
   * initialization of the component
   */
  useEffect(() => {
    const user = userData.user;
    const profile = userData.profile;
    let filter = {};
    let gender = null;
    if (typeof profile.milestone_filter === "string") {
      filter = JSON.parse(profile.milestone_filter);
    } else if (typeof profile.milestone_filter === "object") {
      filter = profile.milestone_filter;
    }

    if (profile && profile.id) {
      setState((prev) => ({
        ...prev,
        username: user.username,
        email: user.email,
        profile_username: profile.username,
        other_name: profile.other_name,
        gender: gender,
        pronoun: profile.pronoun,
        address: profile.address,
        adultContent: profile.show_adult,
        featured: profile.show_featured,
        showNotifications: profile.show_notifications ? true : false,
        allowTagging: profile.allow_tagging ? true : false,
        turnOnQuickCreate:profile?.quick_create_milestone ? true : false,
        metadata: profile.metadata ? profile.metadata : {},
        profileTypes: profile.profile_type ? profile.profile_type.type : null,
        profileStyle: profile.profile_type ? profile.profile_type.style : null,
        profileGroup: profile.profile_type ? profile.profile_type.group : [],
        job_role: filter?.job_role || null,
        category: filter?.category || null,
        sort: filter?.sort || null,
        hero: profile?.hero ? profile?.hero : {},
        heroSocialMedia: profile.hero ? profile.hero.socialMedia : null,
        heroCTA: profile.hero ? profile.hero.heroCTA : null,
        dateFormat: profile.dateFormat ? true : false,
        first_name: user.first_name,
        last_name: user.last_name,
        displayName: profile?.displayName,
        profile_name: profile?.profile_name,
        privacy: profile?.privacy,
        other_hero_social_media:  profile.hero ? profile.hero.other_hero_social_media : null,
        followers:profile.followers,
        // profile lang -> saved site lang -> English
        lang:
          normalizeLang(profile?.lang) ||
          normalizeLang(localStorage.getItem("lang")) ||
          "en",

      }));
      if (profile.gender === "Male" || profile.gender === "Female") {
        setState((prev) => ({
          ...prev,
          gender: profile.gender,
        }));
      } else if (profile.gender && profile.gender != "null" || profile.gender === "Other") {
        setState((prev) => ({
          ...prev,
          gender: "Other",
          other_gender: profile.gender === "null" ? null : profile.gender,
        }));
      }
      setMembers(
        profile.profile_type?.members
          ? JSON.parse(profile.profile_type.members)
          : []
      );
      if(profile?.other_names){ 
        setOtherNames(profile?.other_names || []);
        let newArray = [...sets_display_name, ...profile?.other_names];
        setDisplayName(newArray); 
      }
      getSocialMedia();
      getCoverPhotos();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData?.profile, userData?.username]); 

  useEffect(() => {
    const profile = userData.profile;

    if (!occupation.length) {
      if (profile.occupations) {
        let values = occupations.filter(
          (o) => profile.occupations.indexOf(o.label) !== -1
        );
        setOccupation(values);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [occupations, userData?.profile]);

  const showMembers = useMemo(() => {
    let isGroup = state?.profileTypes === "group";
    let isTeam = state?.profileTypes === "team";
    let isBusiness = state?.profileTypes === "business";
    if (isGroup || isTeam || isBusiness) {
      return true;
    } else {
      return false;
    }
  }, [state.profileTypes]);

  const showGender = useMemo(() => {
    let hasGender = !gender.filter((g) => g.value === state.gender).length;
    if (state.gender && state.gender != "null") {
      if (state.gender === "Other" || hasGender) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }, [state.gender]);

  return (
    <div className="mt-6 w-full container-max-width bg-white rounded-md">
      {/* content */}
      <div className="pt-12.5 pb-10 px-7.5 1md:pl-24.5 1md:pr-56">
        <div className="w-full 3md:flex -mb-6">
          <div className="w-full mb-5 3md:w-6/20 3md:mb-0">
            <div className="w-full flex flex-row gap-x-2 items-center">
              <p className="text-lg text-lightBlack font-semibold">
                {t('personalInformation')}
              </p>
              <PopInfo
                containerClass="relative"
                type="personal_information_general"
                responsive={{
                  left: "200px",
                  right: "200px",
                }}
              />
            </div>
          </div>
          {/* forms */}
          <div className="w-full 3md:w-14/20">
            <ImageUpload
              ref={fileInputRef}
              label={t('profilePicture')}
              image={profile}
              accept="image/*"
              icon={<FiCamera className="text-white text-lg" />}
              id="profile-photo"
              onChange={(e) => onUploadImage(e, "profile")}
              onClick={editProfileHandler}
              error={uploadErrors ? uploadErrors["profile"] : null}
              isButton={true}
            />
            <ImageUpload
              label={t('coverPhoto')}
              accept="image/*"
              image={cover}
              icon={<FiCamera className="text-white text-lg mr-2" />}
              className="absolute px-4 text-xs text-white font-semibold right-2 top-2 h-9 bg-black bg-opacity-50 rounded-md flex items-center justify-center"
              innerLabel={cover ? "Edit Photo" : "Edit Photo"}
              wrapperClass="relative w-full 4sm:w-538 h-38 bg-thBg rounded-md"
              id="cover-photo"
              isButton={true}
              onClick={editCoverHandler}
              onChange={(e) => onUploadImage(e, "cover")}
              error={uploadErrors ? uploadErrors["cover"] : null}
            />
            {
              state.profileTypes === 'personal'
              ?
              <div className="flex gap-4">
                <Input
                  inputContainerClass="form-input-container"
                  value={state?.first_name || ""}
                  name="first_name"
                  outsideLabel={t('firstName')}
                  placeholder="first name"
                  outsideLabelClass="text-sm font-bold text-darkerGray marked"
                  noLabelPaddingY="1rem"
                  type="text"
                  onChange={handleInputChange}
                  errorMessage={state.validationErrors?.first_name}
                  errorMessagePosition="bottom"
                />
                <Input
                  inputContainerClass="form-input-container"
                  value={state?.last_name || ""}
                  name="last_name"
                  outsideLabel={t('lastName')}
                  placeholder="last name"
                  outsideLabelClass="text-sm font-bold text-darkerGray marked"
                  noLabelPaddingY="1rem"
                  type="text"
                  onChange={handleInputChange}
                  errorMessage={state.validationErrors?.last_name}
                  errorMessagePosition="bottom"
                />
              </div>
              :<></>
            }
            <Input
              disabled={true}
              inputContainerClass="form-input-container"
              value={state?.profile_username || ""}
              name="profile_username"
              outsideLabel={t('username')}
              placeholder="username"
              outsideLabelClass="text-sm font-bold text-darkerGray marked"
              noLabelPaddingY="1rem"
              type="text"
              onChange={handleInputChange}
              errorMessage={state.validationErrors?.profile_username}
              errorMessagePosition="bottom"
            />

            <Input
              inputContainerClass="form-input-container"
              value={state?.profile_name || ""}
              name="profile_name"
              outsideLabel={t('profileName')}
              placeholder="Profile Name"
              outsideLabelClass="text-sm font-bold text-darkerGray marked"
              noLabelPaddingY="1rem"
              type="text"
              onChange={handleInputChange}
              errorMessage={state.validationErrors?.profile_name}
              errorMessagePosition="bottom"
            />
            <Input
              inputContainerClass="form-input-container"
              value={state?.other_name || ""}
              name="other_name"
              outsideLabel={t('otherNames')}
              optional={true}
              placeholder={placeholder}
              outsideLabelClass="text-sm font-bold text-darkerGray"
              noLabelPaddingY="1rem"
              type="text"
              onChange={handleInputChange}
            />
            {/* <div className="w-full">
              <div className="text-sm font-bold text-darkerGray mb-2">Other Name <span className="font-normal">{" (optional)"}</span></div>
                <DragDropSelect
                  items={otherNames}
                  errors={state.validationErrors}
                  onAdd={onAddOtherName}
                  onChange={(e, index) => onChangeOtherName(e, index)}  
                  onRemove={(index) => onRemoveOtherName(index)}
                  setItems={setOtherNames}
                />
              </div> */}
            {/* <div className="flex gap-2 my-5">
              <Select
                  label="Display Name"
                  options={displayName}
                  placeholder="Select Name"
                  name="displayName"
                  className="h-[3rem]"
                  value={
                    state.displayName &&
                    displayName.filter((g) => g.value === state.displayName)
                  }
                  onChange={(e) =>
                    handleInputChange({
                      target: { name: "displayName", value: e.value },
                    }, true)
                  }
                  errorMessage={state.validationErrors?.gender}
                />
                {
                  state.displayName === 'Other Name' &&
                  <Select
                  label="Other Name"
                  options={otherNames}
                  placeholder="Select Name"
                  name="other_name"
                  className="h-[3rem]"
                  value={
                    state.other_name &&
                    otherNames.filter((g) => g.value === state.other_name)
                  }
                  onChange={(e) =>
                    handleInputChange({
                      target: { name: "other_name", value: e.value },
                    })
                  }
                  errorMessage={state.validationErrors?.gender}
                />
                }
            </div> */}
            {
              state.profileTypes === 'personal' || state.profileTypes === 'character'
              ?
              <div className="w-full grid 3md:grid-cols-2 gap-4">
                <div>
                  <Select
                    label={t("gender")}
                    options={gender}
                    placeholder={t("selectGender")}
                    name="gender"
                    className="h-[3rem]"
                    value={
                      state.gender &&
                      gender.filter((g) => g.value === state.gender)
                    }
                    onChange={(e) =>
                      handleInputChange({
                        target: { name: "gender", value: e.value },
                      })
                    }
                    errorMessage={state.validationErrors?.gender}
                  />
                  {showGender && (
                    <Input
                      inputContainerClass="form-input-container"
                      outsideLabelClass="text-sm font-bold text-darkerGray mr-4"
                      value={state.other_gender || ""}
                      outsideLabel={t("SpecifyGender")}
                      //outsideLabel="Specify Gender"
                      noLabelPaddingY="1rem"
                      type="text"
                      errorMessage={state.validationErrors?.other_gender}
                      onChange={(e) =>
                        handleInputChange({
                          target: {
                            name: "other_gender",
                            value: e.target.value,
                          },
                        })
                      }
                    />
                  )}
                </div>
                <div>
                  <Input
                    inputContainerClass="form-input-container"
                    value={state.pronoun || ""}
                    name="pronoun"
                    outsideLabel={t("pronouns")}
                    placeholder={t("pronouns")}
                    optional={true}
                    outsideLabelClass="text-sm font-bold text-darkerGray"
                    noLabelPaddingY="0.8rem"
                    type="text"
                    onChange={handleInputChange}
                    errorMessagePosition="bottom"
                  />
                </div>
              </div>
              :
              <></>
            }
            {/* <Input
              inputContainerClass="form-input-container"
              value={state?.address || ""}
              name="address"
              outsideLabel="Address"
              placeholder="Melbourne, Australia"
              outsideLabelClass="text-sm font-bold text-darkerGray"
              noLabelPaddingY="1rem"
              type="text"
              onChange={handleInputChange}
              errorMessage={state.validationErrors?.address}
              errorMessagePosition="bottom" 
            /> */}

            <div className="form-input-container">
              <label htmlFor="address" className="text-sm font-bold text-darkerGray leading-4">{t('location_egCityStateCountry')}</label>
              <div className="input-wrapper">
                <input ref={ref}  
                  className="input-class w-full" type="text" name="address" placeholder="Melbourne VIC, Australia" 
                  value={state?.address || ""}
                  onChange={handleInputChange}
                  style={{
                    padding:  "1rem",
                  }}
                  />
                  {
                    state.validationErrors?.address && 
                    <p className="input-error-message">* {state.validationErrors?.address}</p>
                  }
                </div>
              </div>

              
             
            <CreatableSelect
              className="capitalize"
              label={`${state.profileTypes === 'personal' ? `${t('occupationsSkills')} (eg. Actor, Director)` : `${t('categoryType')} ${sampleCategory?.[state.profileTypes] || ''}`}`}
              options={occupations.filter(item => item.profile_type === (state.profileTypes === 'character' ? 'personal' : state.profileTypes) )}
              placeholder={`${state.profileTypes === 'personal' ? t('selectOccupations') : 'Add Category or Type'}`}
              name="occupations"
              isMulti
              value={occupation}
              onChange={(e) => onChangeOccupation(e)}
              onCreateOption={createOccupation}
            />
          </div>
        </div>
        {/* social media */}
        <div className="w-full mt-15 3md:flex -mb-6">
          <div className="w-full mb-5 3md:w-6/20 3md:mb-0">
            <div className="w-full flex flex-row gap-x-2 items-center">
              <p className="text-lg text-lightBlack font-semibold">
                <div>{t("socialMedia")} </div>
                <div>{t("orProfilePage")}</div>
              </p>
              <PopInfo containerClass="relative" type="social_media" />
            </div>
            <p className="text-[12px] text-slate-500">
              {t("egFacebookInstagramIMDb")}
            </p>
          </div>
          {/* forms */}
          <div className="w-full 3md:w-14/20">
            <SocialSelect
              setItems={setSocials}
              options={socialOptions}
              items={socials}
              errors={state.validationErrors}
              onAdd={onAddSocials}
              onChange={(e, index) => onTypeLinkSocial(e, index, "social")}
              onSelect={(e, index) => onSelectSocial(e, index)}
              onBlur={(e, index) => checkUrl(e, index, "social")}
              onRemove={(index) => onRemoveSocials(index, "social")}
            />
          </div>
        </div>
        {/* website media */}
        <div className="w-full mt-15 3md:flex -mb-6">
          <div className="w-full mb-5 3md:w-6/20 3md:mb-0">
            <div className="w-full flex flex-row gap-x-2 items-center">
              <p className="text-lg text-lightBlack font-semibold">{t("websites")}</p>
              <PopInfo
                containerClass="relative"
                type="website"
                responsive={{
                  left: "125px",
                  right: "125px",
                }}
              />
            </div>
          </div>
          {/* forms */}
          <div className="w-full 3md:w-14/20">
            <WebsiteSelect
              items={websites}
              errors={state.validationErrors}
              onAdd={onAddSocials}
              onChange={(e, index) => onTypeLinkSocial(e, index, "website")}
              onLabelChange={onLabelChange}
              onSelect={(e, index) => onSelectSocial(e, index)}
              onBlur={(e, index) => checkUrl(e, index, "website")}
              onRemove={(index) => onRemoveSocials(index, "website")}
              setItems={setWebsites}
            />
          </div>
        </div>
        {/* hero button */}
        <div className="w-full mt-15 3md:flex -mb-6">
          <div className="w-full mb-5 3md:w-6/20 3md:mb-0">
            <div className="w-full flex flex-row gap-x-2 items-center">
              <p className="text-lg text-lightBlack font-semibold">
                {t("heroButton")}
              </p>
              <PopInfo containerClass="relative" type="hero_button" />
            </div>
            <p className="text-[12px] text-slate-500">
              {/* Link to where you can take payments */}
              {/* {`Link to where you can take payments (e.g. Patreon, GoFundMe, Fiverr, UpWork, etc)`} */} 
              {t("linkToWhereYouCanTakePayments")}
            </p>
          </div>
          {/* forms */}
          {
            isSubscribed ?
            <div className="w-full 3md:w-14/20">
              <div className="w-full 7sm:grid 4sm:grid-cols-3 gap-x-4 gap-y-2 items-center">
                <Select
                  options={sortedHeroCTAs}
                  placeholder={t("select")}
                  name="heroCTA"
                  value={
                    state.heroCTA &&
                    heroCTAs.filter((hs) => hs.value === state.heroCTA)
                  }
                  onChange={(e) =>
                    handleInputChange({
                      target: { name: "heroCTA", value: e?.value || null },
                    })
                  }
                isClearable={true}

                />
                <Select
                isClearable={true}
                  options={sortedHeroTypes}
                  placeholder={t("select")}
                  name="heroSocialMedia"
                  value={
                    state.heroSocialMedia &&
                    heroTypes.filter((hs) => hs.value === state.heroSocialMedia)
                  }
                  onChange={(e) =>
                    handleInputChange({
                      target: { name: "heroSocialMedia", value: e?.value || null },
                    })
                  }
                />
                <Input
                  inputContainerClass="form-input-container"
                  value={state?.hero?.link}
                  name="link"
                  placeholder="https://www.link.com/"
                  outsideLabelClass="text-sm font-bold text-darkerGray"
                  noLabelPaddingY="13px"
                  type="text"
                  onChange={(e) => handleInputObjectChange(e, "hero")}
                  errorMessage={state.validationErrors?.hero?.link}
                />
              </div>
                {state.heroSocialMedia === "Other" && (
                  <div className="4sm:w-[50%]">
                    <div className="flex items-center">
                      {/* todo: specify */}
                      <Input
                        inputContainerClass="form-input-container"
                        outsideLabelClass="text-sm font-bold text-darkerGray mr-4"
                        value={state.other_hero_social_media}
                        outsideLabel={t("OtherWebsiteName")}
                        //outsideLabel="Other Website Name"
                        noLabelPaddingY="1rem"
                        type="text"
                        onChange={(e) =>
                          handleInputChange({
                            target: {
                              name: "other_hero_social_media",
                              value: e.target.value,
                            },
                          })
                        }
                        errorMessage={state.validationErrors?.other_hero_social_media}
              
                      />
                    </div>
                  </div>
                )}
              <div className="w-full flex items-center gap-4">
                {state?.hero?.link && (
                    <div className="w-full 7sm:w-[350px] flex justify-start">
                      <ToolTip
                        value={`${heroCTAs.filter((hs) => hs.value === state.heroCTA)[0]?.label || t('supportMeOn')} ${
                          state.heroSocialMedia === "Other" ? state.other_hero_social_media : heroTypes.find(item => item.value === state.heroSocialMedia)?.label
                        }`}
                        backgroundColor="#0c6ed1"
                        color="white">
                        <button
                          className="text-xs font-semibold text-lightBlack hidden 3md:flex items-center
                                    py-2 mb-5 3md:mb-0 3md:py-1 px-2 bg-thBg hover:bg-gray gap-1 rounded-md group-hover:opacity-100 w-[10rem] justify-between h-12"
                          onClick={() => window.open(state?.hero?.link, "_blank")}>
                          <p className="mt-0.5 w-full text-center">
                            {heroCTAs.filter((hs) => hs.value === state.heroCTA)[0]?.label || t('supportMeOn')}
                          </p>
                          {heroIcon(state.heroSocialMedia,state?.hero?.link)}
                        </button>
                      </ToolTip>
                    </div>
                  )}
                  
              </div>
            </div>:
            <div className="w-full 3md:w-14/20">
              <UpgradePremium
                styleProp="list"
                customHeadline={"Upgrade to Unlock"}
                customText="Link payment platforms and start collecting income directly."
              />
            </div>
          }
        </div>
        {/* Profile types */}
        <div className="w-full mt-10 3md:flex">
          <div className="w-full 3md:w-6/20 3md:mb-0">
            <div className="w-full flex flex-row gap-x-2 items-center">
              <p className="text-lg text-lightBlack font-semibold">
                {t('profileTypes')}
              </p>
              <PopInfo containerClass="relative" type="profile_types" />
            </div>
          </div>
          {/* forms */}
          <div className="w-full 3md:w-14/20">
            <div className="w-full grid 4sm:grid-cols-2 gap-x-4 items-center">
              <Select
                label={t("type")}
                options={filteredProfileTypes}
                placeholder={t('selectType')}
                disableInput={state.profileTypes === 'personal'}
                name="type"
                value={
                  state.profileTypes &&
                  profileTypes.filter((pt) => pt.value === state.profileTypes)
                }
                onChange={(e) =>
                  handleInputChange({
                    target: { name: "profileTypes", value: e.value },
                  })
                }
              />
            </div>
            {
                showMembers && 
                <div className="text-sm text-darkerGray mb-8">
                  <p className="inline-block">
                  <span className="font-bold text-[#ffa24c] gap-2 items-center inline-block pr-1"><FiAlertCircle className="inline-block"/> {t('warning')}:</span>
                  {/* Changing the your profile type will <span className="font-bold text-darkerGray">remove your verified badge</span>.
                  This means that you have to verify your account once you update your type again. */}
                  <Trans
                    i18nKey="profileTypeChangeWarning"
                    components={[
                      <span className="font-bold text-darkerGray" />
                    ]}
                  />
                  </p>  
                </div>
              }
          </div>
        </div> 
        {/* Privacy */}
        <div className="w-full 3md:flex">
          <div className="w-full 3md:w-6/20 3md:mb-0">
            <div className="w-full flex flex-row gap-x-2 items-center">
              <p className="text-lg text-lightBlack font-semibold">
                {t('privacy')}
              </p>
              <PopInfo containerClass="relative" type="privacy" />
            </div>
          </div>
          {/* forms */}
          {/* <div className="w-full 3md:w-14/20">
            <div className="flex space-x-6"> */}
            <div className="w-full 3md:w-14/20">
            <div className="w-full grid 4sm:grid-cols-2 gap-x-4 items-center">
            <Select
                  options={privacies}
                  placeholder="Please Select"
                  name="privacy"
                  height={58}
                  onChange={(e) =>
                    handleInputChange({
                      target: { name: "privacy", value: e.value },
                    })
                  }
                  value={
                    state.privacy &&
                    privacies.filter((g) => g.value === state.privacy)
                  }
                  labelClass="text-sm font-bold text-darkerGray leading-4 marked"
                  errorMessage={state.validationErrors?.privacies}
                />
            </div>
          </div>
        </div>
        {/* Languages */}
        <div className="w-full 3md:flex">
          <div className="w-full 3md:w-6/20 3md:mb-0">
            <div className="w-full flex flex-row gap-x-2 items-center">
              <p className="text-lg text-lightBlack font-semibold">
                {t('language')}
              </p>
              <PopInfo containerClass="relative" type="language" />
            </div>
            <p className="text-[12px] text-slate-500">{t('LanguageSite')}</p>
          </div>
          {/* forms */}
          {/* <div className="w-full 3md:w-14/20">
            <div className="flex space-x-6"> */}
            <div className="w-full 3md:w-14/20">
            <div className="w-full grid 4sm:grid-cols-2 gap-x-4 items-center">
            <Select
                  options={sortedLanguages}
                  placeholder={t('pleaseSelect')}
                  name="lang"
                  height={58}
                  onChange={(e) =>
                    handleInputChange({
                      target: { name: "lang", value: e.value },
                    })
                    // onChangeLang(e.value)
                  }
                  // Always resolve to a real option: current lang -> English -> nothing
                  value={
                    sortedLanguages.find((l) => l.value === state.lang) ||
                    sortedLanguages.find((l) => l.value === "en") ||
                    null
                  }
                  labelClass="text-sm font-bold text-darkerGray leading-4 marked"
                  errorMessage={state.validationErrors?.lang}
                />
            </div>
          </div>
        
        {/* Date format */}
        </div>
        {
          state.profileTypes === 'personal' &&
            <div className="w-full 3md:flex">
              <div className="w-full 3md:w-6/20 3md:mb-0">
                <div className="w-full flex flex-row gap-x-2 items-center">
                  <p className="text-lg text-lightBlack font-semibold">
                    {t('dateFormat')}
                  </p>
                  <PopInfo containerClass="relative" type="date_format" />
                </div>
              </div>
              {/* forms */}
              <div className="w-full 3md:w-14/20">
              <div className="w-full grid 4sm:grid-cols-2 gap-x-4 items-center">
                <Select
                  options={dateForamtList}
                  placeholder="Please Select"
                  name="adultContent"
                  height={58}
                  onChange={(e) =>
                    handleInputChange({
                      target: { name: "dateFormat", value: e.value },
                    })
                  }
                  value={
                    dateForamtList.find((g) => g.value === state.dateFormat)
                  }
                  labelClass="text-sm font-bold text-darkerGray leading-4 marked"
                  errorMessage={state.validationErrors?.dateFormat}
                />
              </div>
              

                {/* <div className="flex space-x-6">
                  <div>
                    <Toggle
                      checked={state.dateFormat}
                      name="dateFormat"
                      onChange={(e) =>
                        setState((prev) => ({
                          ...prev,
                          dateFormat: e?.target?.checked,
                        }))
                      }
                    />
                  </div>
                  <div>
                    <p className="text-lg font-medium text-lightBlack">
                      {!state.dateFormat ? t("USA") : t("international")}
                    </p>
                    <p className="text-md text-lightBlack">
                      {!state.dateFormat
                        ? t("monthDayYearFormat")
                        : t("dayMonthYearFormat")}
                    </p>
                  </div>
                </div> */}
              </div>
            </div>
        }
        {/* Follower show/hide */}
        <div className="w-full 3md:flex">
          <div className="w-full  mb-5 3md:w-6/20 3md:mb-0">
            <div className="w-full flex flex-row gap-x-2 items-center">
              <p className="text-lg text-lightBlack font-semibold">
                Followers
              </p>
              <PopInfo containerClass="relative" type="followers_show_hide" />
            </div>
          </div>
          {/* forms */}
          <div className="w-full 3md:w-14/20">
            <div className="flex space-x-6 items-center">
              <div>
                <Toggle
                  checked={state.followers}
                  name="dateFormat"
                  onChange={(e) =>
                    setState((prev) => ({
                      ...prev,
                      followers: e?.target?.checked,
                    }))
                  }
                />
              </div>
              <div>
                <p className="text-lg font-medium text-lightBlack">
                  {state?.followers ? 'Show' : 'Hide'} Followers
                </p> 
              </div>
            </div>
          </div>
        </div>
        <div className="w-full mt-8 3md:flex">
          <div className="w-full  mb-5 3md:w-6/20 3md:mb-0">
            <div className="w-full flex flex-row gap-x-2 items-center">
              <p className="text-lg text-lightBlack font-semibold">
                {t("allowTagging")}
              </p>
              <PopInfo containerClass="relative" type="allow_tagging" />
            </div>
          </div>
          {/* forms */}
          <div className="w-full 3md:w-14/20">
            <div className="flex space-x-6">
              <div>
                <Toggle
                  checked={state.allowTagging}
                  name="tagging"
                  onChange={(e) =>
                    setState((prev) => ({
                      ...prev,
                      allowTagging: e?.target?.checked,
                    }))
                  }
                />
              </div>
              <div>
                <p className="text-lg font-medium text-lightBlack">{t("tagMentions")}</p>
                <p className="text-md text-lightBlack">
                  {state.allowTagging ? t('allowMentionsInDescription') : t('notAllowMentionsInDescription')}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full mt-6 3md:flex">
          <div className="w-full  mb-5 3md:w-6/20 3md:mb-0">
            <div className="w-full flex flex-row gap-x-2 items-center">
              <p className="text-lg text-lightBlack font-semibold">
                {t("turnOnQuickCreate")}
              </p>
              {/* <PopInfo containerClass="relative" type="allow_tagging" /> */}
            </div>
          </div>
          {/* forms */}
          <div className="w-full 3md:w-14/20">
            <div className="flex space-x-6">
              <div>
                <Toggle
                  checked={state.turnOnQuickCreate}
                  name="tagging"
                  onChange={(e) =>
                    setState((prev) => ({
                      ...prev,
                      turnOnQuickCreate: e?.target?.checked,
                    }))
                  }
                />
              </div>
              <div>
                <p className="text-lg font-medium text-lightBlack">{t("quickCreateMilestone")}</p>
                <p className="text-md text-lightBlack">
                  {state.turnOnQuickCreate ? t('notTurnOnQuickDesc') : t('turnOnQuickDesc')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Filter Milestone Option : remove this section as it's now on the front page*/} 
        {/* <div className="w-full mt-15 3md:flex">
          <div className="w-full mb-5 3md:w-6/20 3md:mb-0">
            <div className="w-full flex flex-row gap-x-2 items-center">
              <p className="text-lg text-lightBlack font-semibold">
                Filter Milestone Option <br />
              </p>
              <PopInfo
                containerClass="relative"
                type="milestone_option"
                responsive={{
                  left: "220px",
                  right: "220px",
                }}
              />
            </div>
            <p className="font-normal text-md">
              Default filter on your milestone page
            </p>
          </div> 
          <div className="w-full 3md:w-14/20 -mb-6">
            <div className="w-full grid 3md:grid-cols-2 gap-4">
              <Select
                formContainer="flex-1"
                options={positionOptions}
                height={70}
                placeholder="Select"
                name="job_role"
                innerLabel="Role/Job Title"
                value={positionOptions.filter(
                  (p) => p.label === state.job_role
                )}
                onChange={(e) =>
                  handleInputChange({
                    target: { name: "job_role", value: e.label },
                  })
                }
              />
              <Select
                formContainer="flex-1"
                options={categoryOptions}
                height={70}
                placeholder="Select"
                name="category"
                innerLabel="Category"
                value={categoryOptions.filter(
                  (c) => c.label === state.category
                )}
                onChange={(e) =>
                  handleInputChange({
                    target: { name: "category", value: e.label },
                  })
                }
              />
              <Select
                formContainer="flex-1"
                options={ORGANIZE_BY}
                height={70}
                placeholder="Select"
                name="sort"
                innerLabel="Sort"
                value={ORGANIZE_BY.filter(
                  (option) => option.label === state.sort
                )}
                onChange={(e) =>
                  handleInputChange({
                    target: { name: "sort", value: e.label },
                  })
                }
              />
            </div> 
          </div>
        </div> */}
        {/* Notification */}
        <div className="w-full mt-6 3md:flex">
          <div className="w-full  mb-5 3md:w-6/20 3md:mb-0">
            <div className="w-full flex flex-row gap-x-2 items-center">
              <p className="text-lg text-lightBlack font-semibold">
                {t("notification")}
              </p>
              <PopInfo containerClass="relative" type="notification" />
            </div>
          </div>
          {/* forms */}
          <div className="w-full 3md:w-14/20">
            <div className="flex space-x-6">
              <div>
                <Toggle
                  checked={state.showNotifications}
                  name="messaging"
                  onChange={(e) =>
                    setState((prev) => ({
                      ...prev,
                      showNotifications: e?.target?.checked,
                    }))
                  }
                />
              </div>
              <div>
                <p className="text-lg font-medium text-lightBlack">{t("messaging")}</p>
                <p className="text-md text-lightBlack">
                  {state.showNotifications ? t('notifyMeWhenSomeoneSends') : t('notNotifyMeWhenSomeoneSends')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {
          state.profileTypes === 'personal' &&
          <>
          {/* Content rating */}
            <div className="w-full mt-6 3md:flex">
              <div className="w-full  mb-5 3md:w-6/20 3md:mb-0">
                <div className="w-full flex flex-row gap-x-2 items-center">
                  <p className="text-lg text-lightBlack font-semibold">
                    {t('contentRating')}
                  </p>
                  <PopInfo
                    containerClass="relative"
                    type="content_rating"
                    responsive={{
                      left: "140px",
                      right: "140px",
                    }}
                  />
                </div>
              </div>
              {/* forms */}
              <div className="w-full 3md:w-14/20">
                <div className="flex space-x-6">
                  <div>
                    <Toggle
                      checked={state.adultContent}
                      name="adultContent"
                      onChange={(e) =>
                        setState((prev) => ({
                          ...prev,
                          adultContent: e?.target?.checked,
                        }))
                      }
                    />
                  </div>
                  <div>
                    <p className="text-lg font-medium text-lightBlack">
                      {t('adultContent')}
                    </p>
                    <p className="text-md text-lightBlack">
                      {state.adultContent ? t('showAdultContentToMe') : t('notShowAdultContentToMe')}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
          </>
        }
      </div>
      {/* footer */}
      <div className="py-5.5 px-7.5 1smd:pl-24.5 1smd:pr-56 border-t-2 border-gray flex flex-col 5sm:flex-row justify-between items-center">
        <div className="mb-6 5sm:mb-0">
          <Link
            to={`/${userData?.user?.username}-${extension}/profile/${userData?.profile?.id}`}>
            <div className="flex items-center font-bold gap-1 hover:text-lightPrimary mb-2 text-sm text-darkerGray w-32">
              <ArrowLeftIcon className="font-bold" />
              <span>{t('backToProfile')}</span>
            </div>
          </Link>
        </div>
        <div className="w-full flex justify-end">
          <Button
            disabled={state.loading}
            buttonName={t("cancel")}
            buttonTextClass="text-xs text-lightBlack font-semibold"
            buttonRadius="6px"
            buttonClass="relative py-4 px-7.5 bg-thBg mr-3.5 hover:bg-gray"
            onClick={() => history.goBack()}
          />
          <Button
            disabled={state.loading}
            buttonName={t("saveChanges")}
            buttonTextClass="text-xs text-white font-semibold flex flex-row items-center gap-2"
            buttonRadius="6px"
            icon={
              state.loading ? (
                <LoadingIndicator className="text-white w-4 h-4" />
              ) : null
            }
            buttonClass="relative py-4 px-10 bg-primary hover:bg-darkPrimary"
            onClick={handleSave}
          />
        </div>
      </div>
    </div>
  );
}
